<template>
  <v-container>

    <div class="wrap">

      <h1>Сводка</h1>
      <department-info></department-info>

      <div class="front-page-list">
        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.3283 14.4353 9.65339 14.3097 9.95671C14.1841 10.26 13.9999 10.5356 13.7678 10.7678C13.5356 10.9999 13.26 11.1841 12.9567 11.3097C12.6534 11.4353 12.3283 11.5 12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5ZM12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9C19 14.25 12 22 12 22C12 22 5 14.25 5 9C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2ZM12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9C7 10 7 12 12 18.71C17 12 17 10 17 9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4Z"
                  fill="#0033A0"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Паспорт региона</div>
          <div class="front-page-list-element-text">Набор показателей и информации о функционировании СЗН всех субъектов РФ.

          </div>
          <!--          <div class="front-page-list-element-date">Срок заполнения – 21 декабря 2021 года</div>-->
          <div class="front-page-list-element-date"></div>
          <div class="front-page-list-element-footer">
            <!--            <router-link to="/passport/info">{{ passportProgress === 0 ? 'начать' : 'продолжить' }}-->
            <router-link to="/passport/info">начать
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </router-link>
            <!--            <span>{{ passportProgress }}%</span>-->
            <span></span>
          </div>
        </div>

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.3283 14.4353 9.65339 14.3097 9.95671C14.1841 10.26 13.9999 10.5356 13.7678 10.7678C13.5356 10.9999 13.26 11.1841 12.9567 11.3097C12.6534 11.4353 12.3283 11.5 12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5ZM12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9C19 14.25 12 22 12 22C12 22 5 14.25 5 9C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2ZM12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9C7 10 7 12 12 18.71C17 12 17 10 17 9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4Z"
                  fill="#0033A0"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Паспорт ЦЗН</div>
          <div class="front-page-list-element-text">Паспорт ЦЗН содержит набор показателей и информации о деятельности отдельных ЦЗН в регионе.

          </div>
          <div class="front-page-list-element-date"></div>
          <div class="front-page-list-element-footer">
            <router-link to="/passportczn/info">начать
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </router-link>
            <span></span>
          </div>
        </div>

<!--        <div class="front-page-list-element">-->
<!--          <div class="front-page-list-element-icon">-->
<!--            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path-->
<!--                  d="M15.5 2C13 2 11 4 11 6.5C11 9 13 11 15.5 11C16.4 11 17.2 10.7 17.9 10.3L21 13.4L22.4 12L19.3 8.9C19.7 8.2 20 7.4 20 6.5C20 4 18 2 15.5 2ZM4 4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V15L18 13V20H4V6H9.03C9.09 5.3 9.26 4.65 9.5 4H4ZM15.5 4C16.9 4 18 5.1 18 6.5C18 7.9 16.9 9 15.5 9C14.1 9 13 7.9 13 6.5C13 5.1 14.1 4 15.5 4Z"-->
<!--                  fill="#0033A0"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div class="front-page-list-element-header">Оперативный мониторинг</div>-->
<!--          <div class="front-page-list-element-text">Оперативный мониторинг выполнения ЦЗН – участниками ФП мероприятий по модернизации (в рамках Единых требований – приказ №302).-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="front-page-list-element-date">Срок заполнения – 21 декабря 2021 года</div>&ndash;&gt;-->
<!--          <div class="front-page-list-element-date"></div>-->
<!--&lt;!&ndash;          <div class="front-page-list-element-footer">&ndash;&gt;-->
<!--&lt;!&ndash;            <router-link to="/monitoring/info">{{ monitoringProgress === 0 ? 'начать' : 'продолжить' }}&ndash;&gt;-->
<!--&lt;!&ndash;              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
<!--&lt;!&ndash;                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"&ndash;&gt;-->
<!--&lt;!&ndash;                      fill="#0033A0"/>&ndash;&gt;-->
<!--&lt;!&ndash;              </svg>&ndash;&gt;-->
<!--&lt;!&ndash;            </router-link>&ndash;&gt;-->
<!--&lt;!&ndash;            <span>{{ monitoringProgress }}%</span>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          <div class="front-page-list-element-footer">-->
<!--            <router-link to="/monitoring/info">начать-->
<!--              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"-->
<!--                      fill="#0033A0"/>-->
<!--              </svg>-->
<!--            </router-link>-->
<!--            <span></span>-->
<!--          </div>-->
<!--        </div>-->

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <v-icon class="icon-item icon-clipboard-text-multiple-outline"></v-icon>
          </div>
          <div class="front-page-list-element-header">Сбор заявок для комплексной модернизации</div>
          <div class="front-page-list-element-text">Подсистема предназначена для сбора заявок на участие регионов в комплексной модернизации и создание форм для сбора различных показателей.
          </div>
          <div class="front-page-list-element-footer">
            <router-link to="/standard">начать
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </router-link>
            <span></span>
          </div>
        </div>

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg width="24" height="24" viewBox="0 -2 18 18" fill="#0033A0" xmlns="http://www.w3.org/2000/svg" class="bi bi-kanban">
              <path d="M13.5 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h11zm-11-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11z"/>
              <path d="M6.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm-4 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm8 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3z"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Индекс клиентоцентричности СЗН (ИКЦ)</div>
          <div class="front-page-list-element-text">Подсистема предназначена для сбора и обработки данных с целью оценки уровня клиентоцентричности работы органов службы занятости населения.</div>
          <!--          <div class="front-page-list-element-date">Дашбордов <span>7</span></div>-->
          <!--          <div class="front-page-list-element-date">Показателей <span>46</span></div>-->
          <div class="front-page-list-element-footer">
            <a href="/clientindex">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </a>
          </div>
        </div>


        <!--div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <v-icon class="icon-item icon-map"></v-icon>
          </div>
          <div class="front-page-list-element-header">Карта СЗН</div>
          <div class="front-page-list-element-text">На интерактивной карте представлены данные о функционировании СЗН субъектов РФ.</div-->
          <!--          <div class="front-page-list-element-date">Центров занятости <span>120</span></div>-->
          <!--div class="front-page-list-element-footer"-->
            <!--            <a href="https://map.testczn.nekadid.ru/">перейти &lt;!&ndash; TODO Поставить продовскую ссылку перед релизом!!!        &ndash;&gt;-->
            <!--a href="https://map.czn-office.ru/">перейти --><!-- TODO Поставить продовскую ссылку перед релизом!!!        -->
              <!--svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </a>
          </div>
        </div-->

        <!--div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <v-icon class="icon-item icon-map"></v-icon>
          </div>
          <div class="front-page-list-element-header">Карта сервисов ЦЗН</div>
          <div class="front-page-list-element-text">Информация о сервисах, предоставляемых ЦЗН, в структурированном виде</div>
          <div class="front-page-list-element-footer">
            <a href="/servicemap">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </a>
          </div>
        </div-->

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.5 2C13 2 11 4 11 6.5C11 9 13 11 15.5 11C16.4 11 17.2 10.7 17.9 10.3L21 13.4L22.4 12L19.3 8.9C19.7 8.2 20 7.4 20 6.5C20 4 18 2 15.5 2ZM4 4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V15L18 13V20H4V6H9.03C9.09 5.3 9.26 4.65 9.5 4H4ZM15.5 4C16.9 4 18 5.1 18 6.5C18 7.9 16.9 9 15.5 9C14.1 9 13 7.9 13 6.5C13 5.1 14.1 4 15.5 4Z"
                  fill="#0033A0"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Мониторинг стандарта организации деятельности</div>
          <div class="front-page-list-element-text">Мониторинг исполнения стандарта организации деятельности органов службы занятости в субъектах Российской Федерации</div>
          <div class="front-page-list-element-footer">
            <router-link to="/orgmonitor">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </router-link>
          </div>
        </div>

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.5 2C13 2 11 4 11 6.5C11 9 13 11 15.5 11C16.4 11 17.2 10.7 17.9 10.3L21 13.4L22.4 12L19.3 8.9C19.7 8.2 20 7.4 20 6.5C20 4 18 2 15.5 2ZM4 4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V15L18 13V20H4V6H9.03C9.09 5.3 9.26 4.65 9.5 4H4ZM15.5 4C16.9 4 18 5.1 18 6.5C18 7.9 16.9 9 15.5 9C14.1 9 13 7.9 13 6.5C13 5.1 14.1 4 15.5 4Z"
                  fill="#0033A0"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Мониторинг исполнения стандартов процессов</div>
          <div class="front-page-list-element-text">Мониторинг исполнения стандартов процессов осуществления органами службы занятости полномочий в области содействия занятости населения</div>
          <div class="front-page-list-element-footer">
            <router-link to="/processmonitor">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </router-link>
          </div>
        </div>

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.5 2C13 2 11 4 11 6.5C11 9 13 11 15.5 11C16.4 11 17.2 10.7 17.9 10.3L21 13.4L22.4 12L19.3 8.9C19.7 8.2 20 7.4 20 6.5C20 4 18 2 15.5 2ZM4 4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V15L18 13V20H4V6H9.03C9.09 5.3 9.26 4.65 9.5 4H4ZM15.5 4C16.9 4 18 5.1 18 6.5C18 7.9 16.9 9 15.5 9C14.1 9 13 7.9 13 6.5C13 5.1 14.1 4 15.5 4Z"
                  fill="#0033A0"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Показатели эффективности и результативности</div>
          <div class="front-page-list-element-text">Мониторинг показателей результативности оказания государственных услуг и показателей эффективности и результативности деятельности</div>
          <div class="front-page-list-element-footer">
            <router-link to="/resultmonitor">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </router-link>
          </div>
        </div>

        <!--div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.5 2C13 2 11 4 11 6.5C11 9 13 11 15.5 11C16.4 11 17.2 10.7 17.9 10.3L21 13.4L22.4 12L19.3 8.9C19.7 8.2 20 7.4 20 6.5C20 4 18 2 15.5 2ZM4 4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V15L18 13V20H4V6H9.03C9.09 5.3 9.26 4.65 9.5 4H4ZM15.5 4C16.9 4 18 5.1 18 6.5C18 7.9 16.9 9 15.5 9C14.1 9 13 7.9 13 6.5C13 5.1 14.1 4 15.5 4Z"
                  fill="#0033A0"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Мониторинг интегрального показателя</div>
          <div class="front-page-list-element-text">Мониторинг интегрального показателя деятельности сети ЦЗН</div>
          <div class="front-page-list-element-footer">
            <router-link to="/integralmonitor">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </router-link>
          </div>
        </div-->

<!--        <div class="front-page-list-element">-->
<!--          <div class="front-page-list-element-icon">-->
<!--            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path-->
<!--                  d="M9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17ZM19 19H5V5H19V19.1V19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"-->
<!--                  fill="#0033A0"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div class="front-page-list-element-header">Рейтинг ЦЗН</div>-->
<!--          <div class="front-page-list-element-text">Рейтинг по показателям соответствия ЦЗН – участников ФП Единым требованиям (Приказ №302).-->
<!--          </div>-->
<!--          <div class="front-page-list-element-date">Срок заполнения – 21 декабря 2021 года</div>-->
<!--          <div class="front-page-list-element-footer">-->
<!--            <a href="/rating">начать-->
<!--              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"-->
<!--                      fill="#0033A0"/>-->
<!--              </svg>-->
<!--            </a>-->
<!--            <span>0%</span>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="front-page-list-element">-->
<!--          <div class="front-page-list-element-icon">-->
<!--            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path-->
<!--                  d="M19 19H5V8H19V19ZM16 1V3H8V1H6V3H5C3.89 3 3 3.89 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V5C21 3.89 20.1 3 19 3H18V1H16ZM17 12H12V17H17V12Z"-->
<!--                  fill="#0033A0"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div class="front-page-list-element-header">Информационные мероприятия</div>-->
<!--          <div class="front-page-list-element-text">Мониторинг реализации мероприятий по информационному освещению-->
<!--            перевода в электронный вид государственных услуг.-->
<!--          </div>-->
<!--          <div class="front-page-list-element-date">Срок заполнения – 21 декабря 2021 года</div>-->
<!--          <div class="front-page-list-element-footer">-->
<!--            <router-link to="/infevents/info">{{ infeventsProgress === 0 ? 'начать' : 'продолжить' }}-->
<!--              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"-->
<!--                      fill="#0033A0"/>-->
<!--              </svg>-->
<!--            </router-link>-->
<!--            <span>{{ infeventsProgress }}%</span>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="front-page-list-element">-->
<!--          <div class="front-page-list-element-icon">-->
<!--            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path-->
<!--                  d="M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2ZM14 13.58V16H13V11.41L14.71 9.71C15.1 9.32 15.1 8.68 14.71 8.29C14.32 7.9 13.68 7.9 13.29 8.29L12 9.59L10.71 8.29C10.32 7.9 9.68 7.9 9.29 8.29C8.9 8.68 8.9 9.32 9.29 9.71L11 11.41V16H10V13.58C8.23 12.81 7 11.05 7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.05 15.77 12.81 14 13.58ZM9 20H15V21C15 21.55 14.55 22 14 22H10C9.45 22 9 21.55 9 21V20Z"-->
<!--                  fill="#0033A0"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div class="front-page-list-element-header">Жизненные ситуации / бизнес-ситуации</div>-->
<!--          <div class="front-page-list-element-text">Учет предоставления услуг органами занятости субъектов Российской-->
<!--            Федерации в рамках комплексов услуг по принципу жизненных ситуаций / бизнес-ситуаций.-->
<!--          </div>-->
<!--          <div class="front-page-list-element-date">Всего услуг / За неделю <span>0 / 0</span></div>-->
<!--          <div class="front-page-list-element-footer">-->
<!--            <a href="/situations">перейти-->
<!--              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"-->
<!--                      fill="#0033A0"/>-->
<!--              </svg>-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_348_521)">
                <path
                    d="M22 3H2C1.47512 3.01747 0.976497 3.23379 0.605143 3.60514C0.23379 3.9765 0.0174689 4.47512 0 5L0 19C0.0174689 19.5249 0.23379 20.0235 0.605143 20.3949C0.976497 20.7662 1.47512 20.9825 2 21H22C22.5249 20.9825 23.0235 20.7662 23.3949 20.3949C23.7662 20.0235 23.9825 19.5249 24 19V5C23.9825 4.47512 23.7662 3.9765 23.3949 3.60514C23.0235 3.23379 22.5249 3.01747 22 3ZM22 19H2V5H22V19ZM14 17V15.75C14 14.09 10.66 13.25 9 13.25C7.34 13.25 4 14.09 4 15.75V17H14ZM9 7C8.50555 7 8.0222 7.14662 7.61107 7.42133C7.19995 7.69603 6.87952 8.08648 6.6903 8.54329C6.50108 9.00011 6.45157 9.50277 6.54804 9.98773C6.6445 10.4727 6.8826 10.9181 7.23223 11.2678C7.58186 11.6174 8.02732 11.8555 8.51227 11.952C8.99723 12.0484 9.49989 11.9989 9.95671 11.8097C10.4135 11.6205 10.804 11.3 11.0787 10.8889C11.3534 10.4778 11.5 9.99445 11.5 9.5C11.5 9.1717 11.4353 8.84661 11.3097 8.54329C11.1841 8.23998 10.9999 7.96438 10.7678 7.73223C10.5356 7.50009 10.26 7.31594 9.95671 7.1903C9.65339 7.06466 9.3283 7 9 7ZM15 10V13H19V10H15Z"
                    fill="#0033A0"/>
              </g>
              <defs>
                <clipPath id="clip0_348_521">
                  <rect fill="white" height="24" width="24"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="front-page-list-element-header">Опросы</div>
          <div class="front-page-list-element-text">Подсистема для проведения анкетирования получателей услуг СЗН, включая обработку результатов.
          </div>
<!--          <div class="front-page-list-element-date">Всего анкет / За неделю <span>1092 / 0</span></div>-->
<!--          <div class="front-page-list-element-date">Активных анкетирований <span>1</span></div>-->
<!--          <div class="front-page-list-element-date">Требуют оценки<span>0</span></div>-->
          <div class="front-page-list-element-footer">
            <a href="/ankets">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </a>
          </div>
        </div>



<!--        <div class="front-page-list-element">-->
<!--          <div class="front-page-list-element-icon">-->
<!--            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path d="M4 19V20H22V22H2V2H4V17C7 17 10 15 12.1 11.4C15.1 6.4 18.4 4 22 4V6C19.2 6 16.5 8.1 13.9 12.5C11.3 16.6 7.7 19 4 19Z"-->
<!--                    fill="#0033A0"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div class="front-page-list-element-header">Аналитика</div>-->
<!--          <div class="front-page-list-element-text">Дашборд по показателям из подсистем Паспорт региона, Паспорт ЦЗН, Мониторинг комплексной модернизации-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="front-page-list-element-date">Дашбордов <span>7</span></div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="front-page-list-element-date">Показателей <span>46</span></div>&ndash;&gt;-->
<!--          <div class="front-page-list-element-footer">-->
<!--            <a href="https://test.bi.czn-office.ru/">перейти-->
<!--              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"-->
<!--                      fill="#0033A0"/>-->
<!--              </svg>-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->

        <div class="front-page-list-element">
          <div class="front-page-list-element-icon">
            <svg width="24" height="24" viewBox="-2 -1.5 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35611 0.060866C3.27927 0.0932114 3.18227 0.149659 3.14049 0.186302C2.92861 0.372287 2.84783 0.780667 2.9755 1.02029C3.01032 1.08564 3.03298 1.14315 3.02582 1.14803C3.01865 1.15291 2.8554 1.21096 2.66308 1.27702C1.65579 1.62305 0.732053 2.47442 0.309228 3.44654C0.065474 4.00696 -0.00246792 4.35248 6.78248e-05 5.0188C0.00199982 5.52101 0.0172545 5.65934 0.10677 5.98658C0.360023 6.91206 0.974197 7.76116 1.76503 8.27912C2.20516 8.56737 4.09003 9.71462 4.21234 9.76872C4.29164 9.8038 4.38272 9.9299 4.54038 10.223C4.66045 10.4461 4.86395 10.7724 4.99259 10.9482C5.30243 11.3715 5.9447 11.9932 6.39377 12.3045C6.73654 12.5421 7.70024 13.0465 7.81133 13.0465C7.85227 13.0465 7.86281 13.3301 7.86245 14.4236L7.86201 15.8006L7.56432 15.9089C6.65781 16.2386 5.94937 16.8532 5.52799 17.6757C5.2615 18.1958 5.15991 18.5818 5.15214 19.1038C5.14638 19.4908 5.1527 19.5261 5.25405 19.6753C5.31946 19.7716 5.43168 19.867 5.53846 19.9171C5.71479 20 5.71556 20 9.99614 20C14.2767 20 14.2775 20 14.4538 19.9171C14.5606 19.867 14.6728 19.7716 14.7382 19.6753C14.8396 19.5261 14.8459 19.4908 14.8401 19.1038C14.8324 18.5818 14.7308 18.1958 14.4643 17.6757C14.0429 16.8532 13.3345 16.2386 12.428 15.9089L12.1303 15.8006L12.1298 14.4236C12.1295 13.3301 12.14 13.0465 12.1809 13.0465C12.292 13.0465 13.2557 12.5421 13.5985 12.3045C14.0476 11.9932 14.6898 11.3715 14.9997 10.9482C15.1283 10.7724 15.3318 10.4461 15.4519 10.223C15.6096 9.9299 15.7006 9.8038 15.7799 9.76872C15.9023 9.71462 17.7871 8.56737 18.2273 8.27912C19.0181 7.76116 19.6323 6.91206 19.8855 5.98658C20.0284 5.46414 20.0391 4.60585 19.9088 4.10079C19.5665 2.77326 18.5749 1.6952 17.3015 1.2662C17.1244 1.20651 16.9736 1.15354 16.9665 1.14842C16.9593 1.14334 16.982 1.08564 17.0168 1.02029C17.1445 0.78051 17.0636 0.372248 16.8515 0.186067C16.6279 -0.0101921 16.9654 -0.0010901 9.98737 0.000550601C4.29816 0.00187879 3.47851 0.00934009 3.35611 0.060866ZM14.7047 4.48167C14.7043 6.2248 14.6869 7.67706 14.6638 7.89004C14.6028 8.4528 14.453 8.9445 14.1818 9.47214C12.653 12.4461 8.49747 12.8766 6.33802 10.2848C5.79477 9.63282 5.42129 8.74687 5.32848 7.89004C5.30541 7.67706 5.28798 6.2248 5.28758 4.48167L5.2869 1.44441H9.99614H14.7054L14.7047 4.48167ZM3.80566 5.14576C3.8123 6.6229 3.81765 7.83449 3.81753 7.83816C3.81661 7.86531 2.60533 7.10195 2.43261 6.96538C1.7734 6.44415 1.42789 5.68563 1.47495 4.86301C1.53927 3.73855 2.31396 2.82655 3.45041 2.53739C3.60819 2.49723 3.74991 2.4634 3.76541 2.46223C3.78087 2.46106 3.79898 3.66866 3.80566 5.14576ZM16.6353 2.5645C17.6958 2.84756 18.4551 3.7748 18.5173 4.86301C18.5644 5.68563 18.2189 6.44415 17.5597 6.96538C17.387 7.10195 16.1757 7.86531 16.1747 7.83816C16.1746 7.83449 16.18 6.62279 16.1866 5.14553L16.1987 2.45962L16.3074 2.48278C16.3671 2.49552 16.5147 2.53231 16.6353 2.5645ZM9.62439 2.80924C9.25768 2.92394 9.04053 3.16293 8.71269 3.81265L8.45561 4.32217L7.84788 4.40905C7.16319 4.50694 6.97385 4.573 6.74692 4.79324C6.49621 5.03658 6.39377 5.27764 6.39377 5.6243C6.39377 6.06096 6.50848 6.25878 7.05802 6.76986L7.49783 7.17887L7.39861 7.718C7.28273 8.34764 7.27818 8.47057 7.36065 8.74016C7.4422 9.00673 7.74947 9.33432 8.02635 9.44992C8.27127 9.55215 8.64547 9.56348 8.89848 9.47625C8.99211 9.44398 9.27708 9.30991 9.53178 9.17826L9.99485 8.93895L10.5288 9.21205C11.1165 9.51269 11.3844 9.58543 11.6955 9.52898C12.2497 9.42835 12.6929 8.92598 12.6929 8.39854C12.6929 8.32076 12.6482 8.01449 12.5937 7.718L12.4945 7.17887L12.9343 6.76986C13.4845 6.25812 13.5989 6.06057 13.5977 5.6243C13.5967 5.26878 13.5028 5.0431 13.2564 4.80395C13.0179 4.57249 12.8362 4.50796 12.1445 4.40905L11.5368 4.32217L11.2595 3.77823C10.9735 3.21715 10.8098 3.01699 10.5139 2.86671C10.3608 2.78897 9.80423 2.75299 9.62439 2.80924ZM10.1862 4.89774C10.2784 5.07822 10.4079 5.28569 10.474 5.3587C10.6383 5.54031 10.9668 5.69149 11.3043 5.74079C11.8524 5.82087 11.8332 5.78302 11.4948 6.11682C11.1739 6.43332 11.0526 6.64466 11.015 6.95226C10.9942 7.12312 11.0477 7.61787 11.1095 7.82542C11.1268 7.8832 11.0617 7.8623 10.7817 7.72007C10.3438 7.49775 10.0761 7.43869 9.77807 7.49873C9.65808 7.52291 9.40278 7.62252 9.21062 7.72007C8.93056 7.8623 8.86552 7.8832 8.88275 7.82542C8.94457 7.61787 8.9981 7.12312 8.97725 6.95226C8.93998 6.64709 8.82237 6.44118 8.50009 6.11702C8.16517 5.78017 8.15044 5.81318 8.66789 5.74177C9.02286 5.69278 9.34896 5.5459 9.51829 5.3587C9.58438 5.28569 9.71391 5.07822 9.80612 4.89774C9.89837 4.71723 9.98386 4.56956 9.99614 4.56956C10.0084 4.56956 10.0939 4.71723 10.1862 4.89774ZM10.6401 14.5505V15.6639H9.99614H9.35214V14.5505V13.4372H9.99614H10.6401V14.5505ZM11.7671 17.2051C12.0735 17.3007 12.3194 17.4269 12.5613 17.6125C12.7816 17.7815 13.0874 18.1686 13.1897 18.4081L13.2523 18.5546H9.99614H6.74L6.80259 18.4081C6.9716 18.0125 7.40722 17.5662 7.82027 17.3654C8.30009 17.1321 8.48017 17.1136 10.1571 17.1259C11.3559 17.1346 11.576 17.1454 11.7671 17.2051Z"
                    fill="#0033A0"/>
            </svg>
          </div>
          <div class="front-page-list-element-header">Конкурс</div>
          <div class="front-page-list-element-text">Подсистема предназначена для проведения Всероссийского конкурса
            профессионального мастерства в сфере содействия занятости населения.</div>
          <!--          <div class="front-page-list-element-date">Дашбордов <span>7</span></div>-->
          <!--          <div class="front-page-list-element-date">Показателей <span>46</span></div>-->
          <div class="front-page-list-element-footer">
            <a href="/event">перейти
              <svg fill="none" height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
                      fill="#0033A0"/>
              </svg>
            </a>
          </div>
        </div>



      </div>

    </div>


  </v-container>
</template>

<script>
import DepartmentInfo from "@/components/elements/DepartmentInfo";

export default {
  name: 'HomeComponent',
  components: {DepartmentInfo},
  data: () => ({
    monitoringProgress: null,
    infeventsProgress: null,
    passportProgress: null
  }),
  methods: {
    //Оперативный мониторинг
    //
    //
    async loadMonitoringConfig() {
      let req
      if (this.configId == null) {
        req = await this.$getApi("/monitoring/getActiveConfig")
      } else {
        req = await this.$getApi("/monitoring/getConfig", {id: this.configId})
      }
      if (req.ok) {
        this.monitoringConfig = req.payload
        this.monitoringConfig.directions = JSON.parse(this.monitoringConfig.directionsJson)
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadMonitoringStageValues() {
      let req = await this.$getApi("/monitoring/getStageValues",
          {userName: this.$behalfUser, configId: this.monitoringConfig.id})
      if (req.ok) {
        this.monitoringValues = req.payload
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadMonitoringProgress() {
      await this.loadMonitoringConfig()
      await this.loadMonitoringStageValues()
      this.monitoringProgress = Math.round(this.getValuesPresent() / this.getStagesCount() * 100)
    },

    getStagesCount() {
      let count = 0
      for (let direction of this.monitoringConfig.directions) {
        for (let action of direction.actions) {
          count += action.stages.length
        }
      }
      return count
    },

    getValuesPresent() {
      return this.monitoringValues.length
    },


    ///Паспорт региона
    //
    //
    async loadPassportConfig() {
      let req
      if (this.configId == null) {
        req = await this.$getApi("/passport/getActiveConfig")
      } else {
        req = await this.$getApi("/passport/getConfig", {id: this.configId})
      }
      if (req.ok) {
        this.passportConfig = req.payload
        this.passportConfig.sections = JSON.parse(this.passportConfig.sectionsJson)
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadPassportValues() {
      let req = await this.$getApi("/passport/getValues",
          {region: this.getRegion().code, configId: this.passportConfig.id})
      if (req.ok) {
        this.passportValues = req.payload
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadPassportProgress() {
      await this.loadPassportConfig()
      await this.loadPassportValues()
      this.passportProgress = Math.round(this.getPassportValuesPresent() / this.getPassportValuesCount() * 100)
    },

    getPassportValuesCount() {
      let count = 0
      for (let section of this.passportConfig.sections) {
        count += section.indicators.length
        for (let indicator of section.indicators) {
          if (indicator.subIndicators != null)
            count += indicator.subIndicators.length
        }
      }
      return count
    },

    getPassportValuesPresent() {
      let count = 0
      for (let v of this.passportValues) {
        if (v.year == null)
          count++
      }
      return count
    },


    //Мониторинг информационных мероприятий
    //
    //
    async loadInfeventsConfig() {
      let req
      if (this.configId == null) {
        req = await this.$getApi("/infevents/getActiveConfig")
      } else {
        req = await this.$getApi("/infevents/getConfig", {id: this.configId})
      }
      if (req.ok) {
        this.infeventsConfig = req.payload
        this.infeventsConfig.directions = JSON.parse(this.infeventsConfig.directionsJson)
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadInfeventsValues() {
      let req = await this.$getApi("/infevents/getStageValues",
          {userName: this.$behalfUser, configId: this.infeventsConfig.id})
      if (req.ok) {
        this.infeventsValues = req.payload
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadInfeventsProgress() {
      await this.loadInfeventsConfig()
      await this.loadInfeventsValues()
      this.infeventsProgress = Math.round(this.getInfeventsValuesPresent() / this.getInfeventsValuesCount() * 100)
    },

    getInfeventsValuesCount() {
      let count = 0
      for (let direction of this.infeventsConfig.directions) {
        count += direction.actions.length
      }
      return count
    },

    getInfeventsValuesPresent() {
      return this.infeventsValues.length
    },

    behalfUserChangeCallback() {
      this.monitoringProgress = null
      this.passportProgress = null
      this.infeventsProgress = null
      this.loadMonitoringProgress()
      this.loadPassportProgress()
      this.loadInfeventsProgress()
    },

    getRegion(){
      return this.$getUserByName(this.$behalfUser).region
    }
  },
  beforeMount() {
    //this.loadMonitoringProgress()
    //this.loadPassportProgress()
    //this.loadInfeventsProgress()
  }
}
</script>
